import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import { FieldConfigKey } from '../../util/enums';
import { getLabelsFromOptions } from '../../util/genericHelpers';
import css from './ListingPage.module.css';

const ProductSizeHighlight = ({ publicData }) => {
  const config = useConfiguration();
  const listingFields = config?.listing?.listingFields || [];
  const sizeValues = publicData?.size;
  const sizeLabels =
    getLabelsFromOptions(FieldConfigKey.SIZE, sizeValues, listingFields) ||
    (Array.isArray(sizeValues) && sizeValues.length > 0 ? sizeValues.join(', ') : null);

  if (!sizeLabels) {
    return null;
  }

  return (
    <div className={css.productSizeHighlight}>
      <span className={css.productSizeLabel}>
        <FormattedMessage id="ListingPage.availableSize" defaultMessage="Available size" />
      </span>
      <span className={css.productSizeValue}>{sizeLabels}</span>
    </div>
  );
};

export default ProductSizeHighlight;
